import { InjectionToken, Signal } from '@angular/core'

/**
 * A source of truth that can *pin* the UI language, overriding the per-account
 * chain resolved at boot (`user.language` -> `localStorage['lang']` -> browser).
 *
 * The lib knows nothing about where a pin comes from. A tenant app decides that:
 * it might be the site the operator is standing in, a kiosk configuration, a
 * customer-scoped contract. All the lib does is honour the signal.
 *
 * Emit `null` when no pin applies, and the account chain keeps its say.
 */
export interface LocalePinSource {
  /** Primary-subtag language code (`'fr'`, `'es'`), or `null` for "no pin". */
  readonly pinnedLang: Signal<string | null>
}

export const LOCALE_PIN_SOURCE = new InjectionToken<LocalePinSource>('LOCALE_PIN_SOURCE')
